@import '../vars.css';

.accent {
    &:not([disabled]) .hint {
        color: var(--button-inverted-accent-hint-color);
    }
}

.primary {
    color: var(--button-inverted-primary-color);
    background-color: var(--button-inverted-primary-base-bg-color);

    &:not([disabled]) .hint {
        color: var(--button-inverted-primary-hint-color);
    }

    @media (hover: hover) {
        &:hover {
            background-color: var(--button-inverted-primary-hover-bg-color);
        }
    }

    &:active {
        background-color: var(--button-inverted-primary-active-bg-color);
    }

    & > .loader {
        color: var(--button-spinner-inverted-primary-color);
    }
}

.secondary {
    background-color: var(--button-inverted-secondary-base-bg-color);

    &:hover {
        background-color: var(--button-inverted-secondary-hover-bg-color);
    }

    &:active {
        background-color: var(--button-inverted-secondary-active-bg-color);
    }
}

.text {
    &:active {
        color: var(--button-inverted-text-active-color);
    }
}

.component[disabled] {
    &.primary {
        color: var(--button-inverted-primary-disabled-color);
        background-color: var(--button-inverted-primary-disabled-bg-color);

        &.loading {
            color: var(--button-inverted-primary-color);
            background-color: var(--button-inverted-primary-base-bg-color);
        }
    }

    &.secondary {
        color: var(--button-inverted-secondary-disabled-color);
        background-color: var(--button-inverted-secondary-disabled-bg-color);
    }

    &.outlined {
        color: var(--button-inverted-outlined-disabled-color);
        border-color: var(--button-inverted-outlined-disabled-border-color);
    }

    &.transparent {
        color: var(--button-inverted-transparent-disabled-color);
    }

    &.text {
        color: var(--button-inverted-text-disabled-color);
    }
}
